/**
 * @generated SignedSource<<515fc3ab26c9c35442907db000dfbc24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type jqlBuilderEmbedded_jqlBuilderWithAi$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_jqlBuilder_JQLBuilder">;
  readonly " $fragmentType": "jqlBuilderEmbedded_jqlBuilderWithAi";
};
export type jqlBuilderEmbedded_jqlBuilderWithAi$key = {
  readonly " $data"?: jqlBuilderEmbedded_jqlBuilderWithAi$data;
  readonly " $fragmentSpreads": FragmentRefs<"jqlBuilderEmbedded_jqlBuilderWithAi">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "jqlBuilderEmbedded_jqlBuilderWithAi",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_jqlBuilder_JQLBuilder"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "ff5e8454ba99d859ec81e83043c22b46";

export default node;
